export default theme => ({

  root: {
    width: '100%',
    height: `calc(100% - ${theme.spacing.unit * 8}px)`
  }

});



// WEBPACK FOOTER //
// ./src/styles/components/Widget.js